import { SETTINGS_PAGES } from '@tenfour/contracts';
import { useAuth, userCan } from '@/components/auth/AuthContext';

/** The directory, rail, and search all offer the same reachable destinations. */
export function useSettingsPages() {
  const { user } = useAuth();
  const isOwner = user?.accountRole !== 'MEMBER' && user?.role !== 'MEMBER';
  return SETTINGS_PAGES.filter((page) => {
    if (page.ownerOnly) return isOwner;
    if (['security', 'account', 'invoices'].includes(page.id)) return true;
    return userCan(user, 'canAdjustSettings');
  });
}
